import { styled } from '@mui/system'

type SponsorProps = {
  sponsorType?: 'official' | 'proud'
}

export const SponsorItemCon = styled('div')<SponsorProps>(({ sponsorType, theme }) => ({
  display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    margin: theme.spacing(1, 0),
  '& a': {
    display: 'flex',
    alignItems: 'center',
    height:  sponsorType === 'official' ? 200 : 150,
    textDecoration: 'none',
    '& .sponsorImg': {
      margin: theme.spacing(2),
    width: sponsorType === 'official' ? 200 : 150,
    [theme.breakpoints.between('sm', 'md')]: {
      margin: theme.spacing(1),
      width: sponsorType === 'official' ? 150 : 120,
    },
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1),
      width: sponsorType === 'official' ? 120 : 100,
    },
    }
  },
}))
